
export const  MATERIAL_LEVEL = {
    1: '大类',
    2: '中类',
    3: '小类',
    4: '细类',
}

export const  PLACE_STATE = {
    2: '三小场所',
    3: '出租房',
    4: '公共场所',
    5: '工业企业',
    6: '大型商业综合体',
    7: '老旧住宅小区',
    8: '住宅建筑',
}



export const  STATE_NAMES = {
    1: '启用',
    0: '禁用'
}

//状态列表
export const STATES_TYPE = {
    enabled: 1,
    disabled: 2
};

export const LEVEL = {
    1: 'A级',
    2: 'B级',
    3: 'C级',
    4: 'D级'

    // 1: '重大隐患',
    // 2: '一般隐患',
}